import Statistic from "common/Statistic/Statistic";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { ICON_TYPES } from "@shared/common/constants";
import { PrecisionType } from "@shared/types";

const BalanceStatistic = ({
  balance,
  precisionSelector,
  title = "Balance",
}) => {
  const value = (
    <TextWithPrecisionAndIcon
      text={balance}
      precisionSelector={precisionSelector}
      precisionType={PrecisionType.BALANCE}
      iconType={ICON_TYPES.DISPLAY_CURRENCY}
    />
  );

  return <Statistic title={title} value={value} />;
};

export default BalanceStatistic;
